import { Component, ErrorInfo } from "react";
import { ErrorBoundaryState } from "./types";

export class ErrorBoundary<T> extends Component<T, ErrorBoundaryState> {
  public state = {
    hasError: false,
  };

  public static getDerivedStateFromError(_: Error): ErrorBoundaryState {
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // eslint-disable-next-line no-console
    console.error("Uncaught error:", error, errorInfo);
  }
}
